/* global axios */
import ApiClient from './ApiClient';

class LiveReportsAPI extends ApiClient {
  constructor() {
    super('live_reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getConversationMetric(params = {}) {
    return axios.get(`${this.url}/conversation_metrics`, { params });
  }

  getGroupedConversations({ groupBy } = { groupBy: 'assignee_id' }) {
    return axios.get(`${this.url}/grouped_conversation_metrics`, {
      params: { group_by: groupBy },
    });
  }

  getConversationMetricItems(params = {}) {
    return axios.get(`${this.url}/conversation_metric_items`, { params });
  }

  getHeatmapMetricItems(params = {}) {
    return axios.get(`${this.url}/heatmap_metric_items`, { params });
  }
}

export default new LiveReportsAPI();
